document.addEventListener('DOMContentLoaded', () => {
  // 获取文本容器和"View More"按钮,pc跟mb超过一定数量段落则隐藏，需要点击view more才显示
  var desctextContainer = document.querySelector('.collection-bottom-desc-content');
  var viewMoreBtn = document.querySelector('.collection-bottom-desc-control');
  if (window.matchMedia("(max-width: 750px)").matches) {
    var linesToShow = 4;
  }else{
    var linesToShow = 8;
  }
  
  var allElements = desctextContainer.querySelectorAll('p,h1, h2, h3,h4,h5,h6,li');
  for (var i = 0; i < allElements.length; i++) {
    if (i >= linesToShow) {
      allElements[i].style.display = 'none';
    }else{
      allElements[i].style.display = 'block';
    }
  }
  
  // 判断是否需要显示"View More"按钮
  var totalLines = allElements.length;
  if (totalLines > linesToShow) {
    viewMoreBtn.style.display = 'block';
  } else {
    viewMoreBtn.style.display = 'none';
  }
  // ADA: set the first heading element tabindex = -1
  desctextContainer.querySelector('h1, h2, h3, h4, h5, h6')?.setAttribute('tabindex', '-1');
  
  
  viewMoreBtn.addEventListener('click', function() {
  
    for (var i = 0; i < allElements.length; i++) {
      allElements[i].style.display = 'block';
    }
    
   
    viewMoreBtn.style.display = 'none';
    desctextContainer.classList.remove('viewless');
  
    // ADA: focus to the first heading element
    desctextContainer.querySelector('h1, h2, h3, h4, h5, h6')?.focus();
  });
  
    });